/** @format */

import React from 'react';
import {createRoot} from 'react-dom/client';
import WorkrouterLogin from './components/auth/workrouter';
import AccountLogin from './components/auth/ajax_login/account';
import Global from '../global/container';

// Components for all pages
Global();

// Add the design system's global scope CSS to the page.
import '@/components/sttark_design_system/index.scss';
import {PreCheckoutAuthenticate} from 'frontier/account/pre_checkout_authenticate';
import {AccountContextProvider} from 'frontier-utilities';
import CheckoutNewAccount from '@/account/components/auth/new_account/checkout';
import GoogleLoginButton from '@/account/components/auth/google_login/google_signin_button';

let bind = document.getElementById('ajax-login');
const ajaxLoginRoot = createRoot(bind);
window.loginRedirect = bind.dataset.redirect;

// Entrypoint that binds everything to the DOM
// Don't put anything else in here
const prefix = window.location.pathname.split('/')[1];

if (prefix === 'admin' || prefix === 'remote') {
    ajaxLoginRoot.render(<WorkrouterLogin redirect={window.loginRedirect} />);
} else {
    if (prefix !== 'carts') {
        // Check the query for new_account=true
        const urlParams = new URLSearchParams(window.location.search);
        const newAccount = Boolean(urlParams.get('new_account') === 'true');
        if (!newAccount) {
            ajaxLoginRoot.render(
                <AccountLogin redirect={window.loginRedirect} newAccount={true} />
            );
        } else {
            ajaxLoginRoot.render(
                <div>
                    <div className="row marg-bottom">
                        <div className="account-head col-sm-12">
                            <h1>Create New Account</h1>
                            <div>
                                Already have an account? (
                                <a
                                    className="btn btn-link p-0"
                                    href={`?new_account=false&redirect=${window.loginRedirect}`}>
                                    Login
                                </a>
                                )
                            </div>
                        </div>
                    </div>
                    <div style={{marginTop: '10px'}}>
                        <GoogleLoginButton buttonType="standard" redirect={window.loginRedirect} />
                    </div>
                    <hr style={{margin: '40px 0'}} />

                    <CheckoutNewAccount
                        loginButtonLabel={'Create New Account'}
                        redirect={window.loginRedirect}
                    />
                </div>
            );
        }
    }
}

bind = document.getElementById('new-account');
if (bind) {
    const newAccountRoot = createRoot(bind);
    let redirect = bind.dataset.redirect;
    let format = bind.dataset.format ? bind.dataset.format : 'inline';

    // Entrypoint that binds everything to the DOM
    // Don't put anything else in here
    //newAccountRoot.render(<NewAccount redirect={redirect} format={format} />);
    newAccountRoot.render(
        <AccountContextProvider>
            <PreCheckoutAuthenticate redirect={redirect} format={format} />
        </AccountContextProvider>
    );
}
